<onsip-header-main>
  <onsip-header-page-title>{{ "ONSIP_I18N.ADD_GROUP" | translate }}</onsip-header-page-title>
</onsip-header-main>
<div class="mat-body-2">
  {{ pricingText }}
</div>
<form
  [formGroup]="groupInfo"
  onsipFormTracking
  name="group-setup-wizard"
  id="group-setup-wizard"
  (ngSubmit)="saveForm()"
>
  <mat-horizontal-stepper
    #stepper
    linear
    class="onsip-stepper-disabled-header onsip-header-full-width"
  >
    <mat-step [stepControl]="groupInfo.controls.basicStep" #basicStep completed="false">
      <ng-template matStepLabel>
        <span>{{ "ONSIP_I18N.BASIC_SETTINGS" | translate }}</span>
      </ng-template>
      <div class="mat-headline-5">{{ "ONSIP_I18N.BASIC_SETTINGS" | translate }}</div>
      <ng-template *ngTemplateOutlet="groupBasicForm"></ng-template>
      <span class="page-view-controls">
        <button
          mat-button
          type="button"
          color="primary"
          class="cancel-button"
          (click)="handleCancel()"
        >
          {{ "ONSIP_I18N.CANCEL" | translate }}
        </button>
        <button
          type="button"
          mat-flat-button
          color="primary"
          [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_NEXT_STEP"
          (click)="goToAddUsers()"
        >
          {{ "ONSIP_I18N.NEXT" | translate }}
        </button>
      </span>
    </mat-step>
    <mat-step [stepControl]="groupInfo.controls.memberStep" #addUsersStep completed="false">
      <ng-template matStepLabel>
        <span>Members</span>
      </ng-template>
      <div class="mat-headline-5">Members</div>
      <ng-template *ngTemplateOutlet="addUsersForm"></ng-template>
      <div class="step-actions">
        <div>
          @if ((mobileView | async) === false) {
          <button
            mat-stroked-button
            mat-button
            type="button"
            color="primary"
            class="prev-step-btn"
            (click)="backStep()"
          >
            {{ "ONSIP_I18N.BACK" | translate }}
          </button>
          }
        </div>
        <span class="page-view-controls">
          <button
            mat-button
            type="button"
            color="primary"
            class="cancel-button"
            (click)="handleCancel()"
          >
            {{ "ONSIP_I18N.CANCEL" | translate }}
          </button>
          @if (mobileView | async) {
          <button
            mat-stroked-button
            mat-button
            type="button"
            color="primary"
            class="prev-step-btn"
            (click)="backStep()"
          >
            {{ "ONSIP_I18N.BACK" | translate }}
          </button>
          }
          <button
            type="button"
            mat-flat-button
            color="primary"
            [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_GO_REVIEW"
            (click)="goToReview()"
          >
            {{ "ONSIP_I18N.NEXT" | translate }}
          </button>
        </span>
      </div>
    </mat-step>
    <mat-step #reviewStep>
      <ng-template matStepLabel>
        <span> {{ "ONSIP_I18N.REVIEW" | translate }}</span>
      </ng-template>
      <div class="mat-headline-5">{{ "ONSIP_I18N.REVIEW" | translate }}</div>
      <ng-template *ngTemplateOutlet="reviewBlock"></ng-template>
      <div class="step-actions">
        <div>
          @if ((mobileView | async) === false) {
          <button
            mat-stroked-button
            mat-button
            type="button"
            color="primary"
            class="prev-step-btn"
            (click)="backStep()"
          >
            {{ "ONSIP_I18N.BACK" | translate }}
          </button>
          }
        </div>
        <span class="page-view-controls">
          <button
            mat-button
            type="button"
            color="primary"
            class="cancel-button"
            (click)="handleCancel()"
          >
            {{ "ONSIP_I18N.CANCEL" | translate }}
          </button>
          @if (mobileView | async) {
          <button
            mat-stroked-button
            mat-button
            type="button"
            color="primary"
            class="prev-step-btn"
            (click)="backStep()"
          >
            {{ "ONSIP_I18N.BACK" | translate }}
          </button>
          }
          <button
            type="submit"
            mat-flat-button
            color="primary"
            class="save-btn"
            [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_REVIEW_FINISH"
          >
            {{ "ONSIP_I18N.SAVE__FINISH_SETUP" | translate }}
          </button>
        </span>
      </div>
    </mat-step>
    <!-- ng-template needs to be inside the stepper for template to work-->
    <ng-template #groupBasicForm let-column>
      <form formGroupName="basicStep">
        <div class="group-form-container onsip-grid-placement">
          <div class="first-column">
            <div class="label-group">
              <div class="mat-body-1 m-bt-12">{{ "ONSIP_I18N.NAME" | translate }}</div>
              <mat-form-field appearance="outline">
                <input
                  [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_NAME"
                  matInput
                  required
                  placeholder="{{ 'ONSIP_I18N.NAME' | translate }}"
                  autocomplete="off"
                  formControlName="Name"
                />
                <mat-error>{{ getNameError() }}</mat-error>
              </mat-form-field>
            </div>
            <div class="label-group">
              <div class="mat-body-1 m-bt-12">
                {{ "ONSIP_I18N.RING_STRATEGY" | translate }}
                <mat-icon
                  [matTooltip]="
                    'ONSIP_I18N.SIMULTANEOUS_RING_RINGS_ALL_MEMBERS_AT_THE_SAME_TIME_HUNT_GROUP_RINGS_EACH_MEMBER_SEQUENTIALLY'
                      | translate
                  "
                  matTooltipClass="onsip-tooltip-background"
                  [matTooltipPosition]="'above'"
                  >help_outline
                </mat-icon>
              </div>
              <mat-radio-group class="label-group" color="primary" formControlName="Ordering">
                <mat-radio-button
                  value="parallel"
                  [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_ORDERING_PARALLEL"
                >
                  {{ "ONSIP_I18N.SIMULTANEOUS_RING" | translate }}
                </mat-radio-button>
                <mat-radio-button value="sequential">
                  {{ "ONSIP_I18N.HUNT_GROUP" | translate }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="label-group">
              <div class="mat-body-1 m-bt-12">
                {{ "ONSIP_I18N.RING_DURATION" | translate }}
                <mat-icon
                  [matTooltip]="
                    'ONSIP_I18N.SETS_THE_AMOUNT_OF_TIME_CALLS_RING_FOR_EACH_MEMBER' | translate
                  "
                  matTooltipClass="onsip-tooltip-background"
                  [matTooltipPosition]="'above'"
                  >help_outline
                </mat-icon>
              </div>
              <div class="two-field-block">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="Timeout">
                    @for (duration of durationArr; track duration) {
                    <mat-option [value]="duration">
                      {{ duration }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div class="mat-body-1 text">
                  {{ "ONSIP_I18N.SECONDS" | translate | lowercase }}
                </div>
              </div>
            </div>
            <div class="label-group">
              <div class="mat-body-1 m-bt-12">
                {{ "ONSIP_I18N.FAILOVER" | translate | titlecase }}
                <mat-icon
                  [matTooltip]="
                    'ONSIP_I18N.FAILOVER_TAKES_EFFECT_AFTER_THE_WHOLE_GROUP_HAS_BEEN_EXHAUSTED_IF_NO_FAILOVER_IS_SET_THE_CALL_IS_THEN_ENDED'
                      | translate
                  "
                  matTooltipClass="onsip-tooltip-background"
                  [matTooltipPosition]="'above'"
                  >help_outline
                </mat-icon>
              </div>
              <onsip-address-autocomplete class="group-failover" formControlName="DefaultAddress">
              </onsip-address-autocomplete>
            </div>
            <div class="label-group">
              <div class="mat-body-1 m-bt-12">SIP address (default)</div>
              <onsip-sip-address-field
                [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_SIP_ADDRESS"
                formControlName="sipAddress"
              >
              </onsip-sip-address-field>
            </div>
            <div class="ext-container">
              <div class="mat-body-1 label-group">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
              <onsip-extensions-list #extensionsList formControlName="extensions">
              </onsip-extensions-list>
            </div>
          </div>
        </div>
      </form>
    </ng-template>
    <ng-template #addUsersForm let-column>
      <div>
        <div class="search onsip-grid-placement">
          <div class="search-member-column">
            <mat-form-field appearance="outline">
              <input
                [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_SEARCH_USER"
                matInput
                [formControl]="searchMember"
                placeholder="Search"
                autocomplete="off"
              />
              <mat-icon matSuffix color="primary">search</mat-icon>
            </mat-form-field>
          </div>
          <div class="member-type-column">
            <mat-form-field appearance="outline">
              <mat-select [formControl]="memberType">
                @for (type of memberTypes; track type) {
                <mat-option [value]="type">
                  {{ type | invokeFunction : selectMemberType }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <span class="members-count-column">
            <span class="mat-body-1">{{ members.value?.length }}/{{ maxItemCount }}</span>
            <span class="members-count">members selected</span>
          </span>
        </div>
        <form formGroupName="memberStep">
          <onsip-select-member-drag-drop
            formControlName="members"
            [searchData]="searchMember.value"
            [filterData]="memberType.value"
            [maxItem]="maxItemCount"
          ></onsip-select-member-drag-drop>
        </form>
        <div class="info">
          *A group is limited to 10 members and 24 device registrations. Individual group members
          can have multiple device registrations.
        </div>
      </div>
    </ng-template>
    <ng-template #reviewBlock let-column>
      <div class="review-block">
        <div class="title">
          {{ "basic settings" | sentenceCase }}
          <button type="button" mat-icon-button class="edit-btn" (click)="editBasicSettings()">
            <mat-icon color="primary">edit</mat-icon>
          </button>
        </div>
        <div class="basic-settings-review onsip-grid-placement">
          <div class="first-column">
            <div class="data-wrapper">
              <div class="mat-body-1">{{ "ONSIP_I18N.GROUP_NAME" | translate }}</div>
              <div [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_REVIEW_NAME">{{ name.value }}</div>
            </div>
            <div class="data-wrapper">
              <div class="mat-body-1">{{ "ONSIP_I18N.RING_STRATEGY" | translate }}</div>
              <div [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_REVIEW_ORDERING">
                {{
                  ordering.value === "parallel"
                    ? ("ONSIP_I18N.SIMULTANEOUS_RING" | translate)
                    : ("ONSIP_I18N.HUNT_GROUP" | translate)
                }}
              </div>
            </div>
            <div class="data-wrapper">
              <div class="mat-body-1">{{ "ONSIP_I18N.RING_DURATION" | translate }}</div>
              <div [attr.data-cy]="E2eLocators.ADMIN_GROUP_ADD_REVIEW_RING_DURATION">
                {{ timeout.value }} seconds
              </div>
            </div>
            <div class="data-wrapper">
              <div class="mat-body-1">{{ "ONSIP_I18N.FAILOVER" | translate | sentenceCase }}</div>
              <div>{{ getTextForViewFromAddress(defaultAddress.value) }}</div>
            </div>
          </div>
          <div class="second-column">
            <div class="data-wrapper">
              <div class="mat-body-1">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
              <div>{{ sipAddress.value }}&#64;{{ domain ? domain : "onsip.com" }} (default)</div>
            </div>
            <div class="data-wrapper">
              <div class="mat-body-1">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
              @if(extensions.value.length){
              <div [attr.data-cy]="E2eLocators.ADMIN_GROUP_EXTENSIONS">
                @for (extension of extensions.value; track extension) {
                <div>
                  {{ extension | formatExtensions }}
                </div>
                }
              </div>
              } @else { No extensions added }
            </div>
          </div>
        </div>
        <div class="title">
          Members
          <button type="button" mat-icon-button class="edit-btn" (click)="editMembers()">
            <mat-icon color="primary">edit</mat-icon>
          </button>
        </div>
        <div class="list-of-members-review onsip-grid-placement">
          <div class="members">
            @for (member of members.value; track member) {
            <div class="member">
              {{ member.name }}
            </div>
            }
          </div>
        </div>
      </div>
    </ng-template>
  </mat-horizontal-stepper>
</form>
<span class="mat-body-2 contact-support"
  >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
  <a class="support-link" [routerLink]="views.CONTACT_SUPPORT">
    {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
  </a>
</span>
